
import { AlertCircle } from "lucide-react";

interface ErrorDisplayProps {
  error: string | null;
  context?: string;
}

export const ErrorDisplay = ({ error, context }: ErrorDisplayProps) => {
  if (!error) return null;
  
  const contextPrefix = context ? `Error during ${context}: ` : "";
  
  return (
    <div className="p-3 mb-4 text-sm text-red-400 dark:text-red-400 bg-red-900/20 dark:bg-red-900/20 rounded-md flex items-start">
      <AlertCircle className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5 text-red-400 dark:text-red-400" />
      <div>
        <p className="font-medium">{contextPrefix}{error}</p>
        {error.includes("fetch") && (
          <p className="mt-1 text-xs text-red-300 dark:text-red-300">This might be due to a network issue. Please check your connection and try again.</p>
        )}
      </div>
    </div>
  );
};
